export default {
  getSettlement: state => state.settlement,
  getSettlements: state => state.settlements,
}
